export default __webpack_public_path__ + "static/media/agrupamentoCNAE.69a0461c.png";